import { Component, OnInit, ViewChild  } from '@angular/core';
import { FileSelectDirective, FileDropDirective, FileUploader, FileItem, FileLikeObject} from 'ng2-file-upload';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SecurityService } from '../../Core/Security/security.service';
import { LogService } from '../../Core/Abstract/log.service';
import { VisualsService } from '../../Core/Abstract/visuals.service';
import { Observable } from 'rxjs';
import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BaseUploaderComponent } from '../../Core/Abstract/baseUploader.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'file-uploader',
    templateUrl: 'fileUploader.component.html'
})

export class FileUploaderComponent extends BaseUploaderComponent implements OnInit{

    @ViewChild('errorModal',{static: false}) public errorModal: ModalDirective;
    @ViewChild('fileUpload',{static: false}) fileUpload: any;

    private id;
    private nm;
    protected continueWithSearch:boolean = true;

    constructor(protected securityService: SecurityService,
        protected configService: ConfigService,
        protected logger: LogService,
        protected visualsService: VisualsService,
        protected eventsEmitterService: EventsEmitterService,
        private route: ActivatedRoute,
        private fb: FormBuilder) {

        super(securityService, configService, logger, visualsService, eventsEmitterService);
        this.getVisuals();
        this.eventsEmitterService.languageChange.subscribe(
            langId => {
                this.getVisuals();
            }
        );
    }

    ngOnInit(): void {

        this.route.params.subscribe(params => {
            this.logger.log(params)
            // Defaults to null if no query param provided.
            // (+) converts string 'id' to a number
            this.id = +params['id'] || null;
            this.nm = params['nm'] || null;
            this.uploader.onBuildItemForm = (item, form) => {
                form.append('id', this.id);
            };

            super.ngOnInit();
        });
    }

    protected initLoader(){
        this.group = 'uploadFiles';
        this.URL = this.configService.getServer() + 'DebtorAttachmentService/uploadFile';
        this.allowedMimeType = ['application/pdf','text/plain',
                                'image/jpeg', 'image/png',
                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                                'application/vnd.ms-powerpoint',
                                'application/vnd.ms-excel',
                                'application/msword'];
        this.uploader =  new FileUploader({  url: this.URL,
            authToken: "Bearer " + this.securityService.getFromStorage('access_token'),
            allowedMimeType:  this.allowedMimeType,
            maxFileSize: this.maxFileSize,
            queueLimit: this.queueLimit
        });

       
    }
}